export const TABLE_NAMES = {
  orders: 'orders',
  clients: 'clients',
  tasks: 'tasks',
  inventory: 'inventory',
  rentals: 'rentals',
  tags: 'tags',
  repairs: 'repairs',
  services: 'services',
  payment_methods: 'payment_methods',
  expenses: 'expenses',
  RENTAL_DENIALS: 'rental_denials',
  NOTIFICATIONS: 'notifications',
  CONVERSATIONS: 'conversations',
  MESSAGES: 'messages',
  CATEGORIES: 'categories',
  sales: 'sales',
  sale_items: 'sale_items',
  // Add other table names here as needed
} as const;
